/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import ReservationAction from '../../../action/reservation'
import { EditViewLayout } from 'ui-library/dist/external/layouts'
import { Checkbox, ContainedButton, EditArea, EditContainer, EditField, EditTitleBar, NormalButton, TextArea, TextInput } from 'ui-library/dist/external/components'
import TransactionAction from '../../../action/transaction'
import Money from '../../unit/Money'

function CreateView(props) {
  const reservation_id = props.match.params.id

  return (
    <EditViewLayout>
      <EditContainer
        titleBar={<EditTitleBar title={`売上登録 [ID:${reservation_id}, ${props.reservation.checkInDate()} ~ ${props.reservation.checkOutDate()}]`} />}
        editAreaTabs={EditAreaTabs(props)}
        editArea={<EditArea fields={EditAreaFields(props)} />}
        footerItems={[
          <NormalButton key="cancel" onClick={ReservationAction.cancelCreationView}>
            キャンセル
          </NormalButton>,
          <ContainedButton
            key="save"
            disabled={!props.view.accommodation_fee_paid && !props.view.accommodation_tax_paid && !props.view.others_paid}
            onClick={() => TransactionAction.requestSave(reservation_id, props.pay, props.accommodation_tax, props.head, props.details)}
          >
            売上登録
          </ContainedButton>
        ]}
      >
        <EditField key="選択">
          <React.Fragment>
            <Checkbox
              nativeControlId="fee"
              name="accommodation_fee_paid"
              checked={props.view.accommodation_fee_paid}
              onChange={e => TransactionAction.onEdit(props.reservation, e.currentTarget.name, e.currentTarget.checked)}
            />
            <label htmlFor="fee">宿泊費</label>
            <Checkbox
              nativeControlId="tax"
              name="accommodation_tax_paid"
              checked={props.view.accommodation_tax_paid}
              onChange={e => TransactionAction.onEdit(props.reservation, e.currentTarget.name, e.currentTarget.checked)}
            />
            <label htmlFor="tax">宿泊税</label>
            <Checkbox
              nativeControlId="other"
              name="others_paid"
              checked={props.view.others_paid}
              onChange={e => TransactionAction.onEdit(props.reservation, e.currentTarget.name, e.currentTarget.checked)}
            />
            <label htmlFor="other">その他</label>
          </React.Fragment>
        </EditField>

        {props.details.map((item, index) => {
          if (item) {
            switch (item.type) {
              case 'accommodation_fee_paid':
                return (
                  <EditField key={`明細${index}`}>
                    <TextInput label="宿泊費" leadingIcon={'money'} value={item.unit_price || 0} onChange={e => TransactionAction.onEditDetail(index, 'unit_price', e.target.value)} fullWidth />
                  </EditField>
                )
              case 'accommodation_tax_paid':
                return (
                  <EditField key={`明細${index}`}>
                    <TextInput label="宿泊税" leadingIcon={'money'} value={item.unit_price || 0} onChange={e => TransactionAction.onEditDetail(index, 'unit_price', e.target.value)} fullWidth />
                  </EditField>
                )
              case 'others_paid':
                return (
                  <EditField key={`明細${index}`}>
                    <TextInput label="その他項目名" leadingIcon={'title'} value={item.title || ''} onChange={e => TransactionAction.onEditDetail(index, 'title', e.target.value)} halfWidth />
                    <TextInput label="金額" leadingIcon={'money'} value={item.unit_price || 0} onChange={e => TransactionAction.onEditDetail(index, 'unit_price', e.target.value)} halfWidth />
                  </EditField>
                )
            }
          }
        })}

        <EditField key="備考">
          <TextArea
            label="備考"
            value={props.head.note || ''}
            onChange={e => {
              TransactionAction.onEdit(props.reservation, 'note', e.currentTarget.value)
            }}
            fullWidth
          />
        </EditField>
      </EditContainer>
    </EditViewLayout>
  )
}

function EditAreaFields(props) {
  if (props.view.accommodation_tax_paid) {
    return [
      <EditField key="宿泊料金">
        <TextInput
          label="宿泊料金 (宿泊税計算)"
          leadingIcon={'money'}
          halfWidth
          value={props.accommodation_tax.price}
          onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'price', e.currentTarget.value)}
        />
        <React.Fragment>
          <Checkbox
            nativeControlId="include_commission"
            name="ota_commission_include"
            checked={props.accommodation_tax.ota_commission_include}
            onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'ota_commission_include', e.currentTarget.checked)}
          />
          <label htmlFor="include_commission">OTA手数料を含める</label>
        </React.Fragment>
      </EditField>,
      <EditField key="手数料">
        <TextInput
          label="OTA手数料 (金額)"
          leadingIcon={'monetization_on'}
          halfWidth
          value={props.accommodation_tax.payment_commission}
          onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'payment_commission', e.currentTarget.value)}
        />
        <TextInput
          label="OTA手数料率 (%)"
          leadingIcon={'check_circle_outline'}
          halfWidth
          value={props.accommodation_tax.ota_commission_rate}
          onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'ota_commission_rate', e.currentTarget.value)}
        />
      </EditField>,
      <EditField key="滞在日数">
        <TextInput
          label="滞在日数 (宿泊税計算)"
          leadingIcon={'today'}
          halfWidth
          value={props.accommodation_tax.number_of_nights}
          onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'number_of_nights', e.currentTarget.value)}
        />
        <TextInput
          label="人数 (宿泊税計算)"
          leadingIcon={'people'}
          halfWidth
          value={props.accommodation_tax.number_of_guests}
          onChange={e => TransactionAction.onEditAccommodationTax(props.reservation, 'number_of_guests', e.currentTarget.value)}
        />
      </EditField>,
      <EditField key="宿泊税計算額">
        <React.Fragment>
          <small>宿泊税(合計)</small>
          <h3>
            <Money>{props.accommodation_tax.calculate()}</Money>
          </h3>
          <small>宿泊税(1人あたり)</small>
          <h3>
            <Money>{props.accommodation_tax.calculatePerPerson()}</Money>
          </h3>
        </React.Fragment>
      </EditField>
    ]
  }

  return []
}

// TransactionAction.onUpdateAccommodationTax(props.accommodation_tax.calculate())}
// TransactionAction.onUpdateAccommodationTax(0)}

function EditAreaTabs(props) {
  if (props.view.accommodation_tax_paid) {
    return ['宿泊税を更新', '宿泊税未回収']
  }

  return []
}

export default CreateView
